import { Check, X } from "lucide-react";
export const NoCodeComparison = () => {
  const comparison = [
    { aspect: "Time to MVP", noCode: "Days-Weeks", code: "Weeks-Months" },
    { aspect: "Initial Cost", noCode: "$0-500/mo", code: "$10K-100K+" },
    { aspect: "Customization", noCode: "Limited", code: "Unlimited" },
    { aspect: "Scalability", noCode: "Platform limits", code: "Unlimited" },
    { aspect: "Learning Curve", noCode: "Low", code: "High" },
    { aspect: "Maintenance", noCode: "Platform handles", code: "You handle" },
  ];
  return (
    <section className="py-8 sm:py-12">
      <h2 className="text-2xl sm:text-3xl font-display font-bold text-foreground mb-6">Quick Comparison</h2>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead><tr className="border-b border-border">
            <th className="text-left py-3 px-4 font-medium text-foreground">Aspect</th>
            <th className="text-left py-3 px-4 font-medium text-primary">No-Code</th>
            <th className="text-left py-3 px-4 font-medium text-chart-2">Custom Code</th>
          </tr></thead>
          <tbody>
            {comparison.map((row, i) => (
              <tr key={i} className="border-b border-border/50">
                <td className="py-3 px-4 font-medium text-foreground">{row.aspect}</td>
                <td className="py-3 px-4 text-muted-foreground">{row.noCode}</td>
                <td className="py-3 px-4 text-muted-foreground">{row.code}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
};
